export class ConflictError extends Error {
    entity: string; 
    identifier: string;
    code: string;
    message:string;
    
    constructor(entity: string, identifier: string, code: string, message: string) {
        super(message);
        this.entity = entity;
        this.identifier = identifier;
        this.code = code;
        this.message = message;
    }
}